export default [{
  key: 'OR',
  label: 'OU'
}, {
  key: 'AND',
  label: 'ET'
}];
